import { useRoute } from 'vue-router'
import qs from 'qs'
import cloneDeep from "lodash/cloneDeep";

export function useQueryConverter(){

    const route = useRoute()

    const fromRoute = (name, map = null) => {
        const queryString   = route.fullPath.split('?')[1] || ''
        const parsed        = qs.parse(queryString)

        if(map){
            return map(name, parsed[name]) || {}
        }

        return parsed[name] || {}
    }

    const fromObject = (name, obj) => {

        const result = {}

        for (const key in cloneDeep(obj)) {
            if(obj[key]){
                if(Array.isArray(obj[key])){
                    result[`${name}[${key}][]`] = obj[key]
                }else{
                    result[`${name}[${key}]`] = obj[key]
                }

            }

        }

        return result
    }

    const hasParam = (name) => {
        const queryString   = route.fullPath.split('?')[1] || ''
        const parsed        = qs.parse(queryString)

        const parts = name.split('.')

        let current = parsed

        for (const part of parts) {
            if (!current || !Object.prototype.hasOwnProperty.call(current, part)) {
                return false
            }
            current = current[part]
        }

        return true
    }

    return {
        fromObject,
        fromRoute,
        hasParam
    }
}